import React from "react";
import { object, array, string, number, bool } from "prop-types";

import LinkTag from "../../molecules/link-tag";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard3.m.css";

const CustomStoryCard3 = ({
  story,
  aspectRatio,
  imageType,
  widths = [140],
  headerType,
  showStoryTypeIcon,
  showHeadlineIcon,
  isExternalStory,
  useAlternateHeadline,
  id,
}) => {
  const headline = getHeadline(story);

  return (
    <div styleName="wrapper" className="custom-story-card-3">
      <LinkTag href={story.url} isExternalStory={isExternalStory}>
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={widths}
          eager={true}
          showStoryTypeIcon={showStoryTypeIcon}
        />
      </LinkTag>

      <LinkTag href={story.url} isExternalStory={isExternalStory}>
        <Headline
          text={headline}
          headerType={headerType}
          headerLevel={2}
          story={showHeadlineIcon ? story : null}
          id={id}
          useAlternateHeadline={useAlternateHeadline}
        />
      </LinkTag>
    </div>
  );
};

CustomStoryCard3.defaultProps = {
  aspectRatio: [5, 4],
  imageType: "image5x4",
  headerType: 3,
  showStoryTypeIcon: true,
  isExternalStory: false,
};

CustomStoryCard3.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  headerType: number,
  showStoryTypeIcon: bool,
  showHeadlineIcon: bool,
  useAlternateHeadline: bool,
  isExternalStory: bool,
  id: string,
};

export default CustomStoryCard3;
